<template lang="pug">
  .component-create-entity-button
    ModalReveal(:ref="componentId")
      button.button.success(slot="trigger", v-if="item") Edit
      button.button.small(slot="trigger", v-else) Add new Segment Rate

      loading-spinner(v-if="loading")
      template(v-else)
        h2(v-if="item !== null") Segment Rate SGR{{item.id}}- SG{{item.segment.id}} {{item.segment.name}}
        h2(v-else) Add new Segment Rate
        .row
          .column
            label Reservation Rate
              select(v-model="body.reservation_rate_id")
                option(v-for="reservation_rate in reservation_rates", :value="reservation_rate.id") RR{{reservation_rate.id}} {{reservation_rate.name}}
        .row.column
          label Description
          Editor(v-model="body.description" )

        .row.column
          label Extended Description
          Editor(v-model="body.extended_description")

        ActionButton(slot="footer", :action="save") Save
        button.button.alert.float-right(slot="footer", @click="$refs[componentId].close()") Cancel
</template>

<script>
import DatePicker from '../../components/structure/DatePicker'
import StartEndTimePicker from './StartEndTimePicker'
import ModalReveal from '../../components/structure/foundation/ModalReveal'
import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
import ActionButton from '../../components/structure/ui/ActionButton'
import SelectizeCommonCost from '../../components/structure/ui/lists/selectize/SelectizeCommonCost'
import LoadingSpinner from "../../components/structure/LoadingSpinner";
import SelectizeVehicleAttributesArrayEdit from "../../components/structure/ui/SelectizeVehicleAttributesArrayEdit";
import Attributes from "../../components/backoffice/tabbed/Attributes";
import Editor from "../../components/structure/ui/Editor";
import MaggieHelper from "../../maggieHelper";

export default {
  name: 'SegmentRateReveal',
  components: {
    Editor,
    Attributes,
    SelectizeVehicleAttributesArrayEdit,
    LoadingSpinner, SelectizeCommonCost, ActionButton, ModalReveal, StartEndTimePicker, DatePicker
  },
  data() {
    return {
      body: {
        segment_id: this.segment !== null ? this.segment.id : null,
        description: "",
        extended_description: "",
        reservation_rate_id: null
      },
      reservation_rates: [],
      loading: false
    }
  },
  created() {
    this.loading = true
    KeplerBackofficeSdk.reservationRates.list.rates((rates) => {
      this.reservation_rates = rates.reverse()
      this.loading = false
      if (this.item !== null) {
        for (let key in this.item) {
          switch (key) {
            case 'reservation_rate':
              this.body.reservation_rate_id = this.item['reservation_rate'].id
              break
            case 'segment':
              this.body.segment_id = this.item['segment'].id
              break
            default:
              this.body[key] = this.item[key]

          }
        }
      }
    })

  },
  methods: {

    save() {
      if (this.item !== null) {
        return KeplerBackofficeSdk.segmentRates.select(this.item.id).edit(this.body, () => {
          this.$emit('itemUpdated')
          this.$refs[this.componentId].close()
        })
      } else {
        return KeplerBackofficeSdk.segmentRates.make(this.body, () => {
          this.$emit('itemUpdated')
          this.$refs[this.componentId].close()
        })
      }
    },
    updateAttribute(attribute) {
      if (attribute.id) {
        return KeplerBackofficeSdk.segmentAttributes.select(attribute.id).edit({value: attribute.value}, () => {
          MaggieHelper.notification('attribute', 'Attribute updated')
        })
      }
      attribute.segment_id = this.item.id
      KeplerBackofficeSdk.segmentAttributes.make(attribute, (data) => {
        this.body.attributes[this.body.attributes.length - 1].id = data.id
      })
    },
    deleteAttribute(attribute) {
      return KeplerBackofficeSdk.segmentAttributes.select(attribute.id).delete(() => {
        MaggieHelper.notification('attribute', 'Attribute updated')
      })
    }
  },
  computed: {
    componentId() {
      return this.item !== null ? `segmentRateReveal-${this.item.id}` : `segmentRateReveal-${this._uid}`
    },

  },
  props: {
    item: {
      type: Object,
      default: null
    },
    segment: {
      type: Object,
      default: null
    },

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SegmentRateReveal.vue?4e47ebd6